export const buildAuthHeaders = (): Record<string, string> => {
    const token = localStorage.getItem('auth.token');
    const headers: Record<string, string> = {
        Accept: '*/*',
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    return headers;
};

export const buildFallbackDownloadUrl = (rawUrl: string): string | null => {
    try {
        const parsed = new URL(rawUrl, window.location.origin);
        const match = parsed.pathname.match(/\/uploadeddocuments\/([^/]+)\/download$/i);
        if (!match?.[1]) {
            return null;
        }

        const documentRef = decodeURIComponent(match[1]);
        if (!documentRef.includes(':')) {
            return null;
        }

        const normalizedId = documentRef.split(':').slice(1).join(':').trim();
        if (!normalizedId) {
            return null;
        }

        parsed.pathname = parsed.pathname.replace(match[1], encodeURIComponent(normalizedId));
        return parsed.toString();
    } catch {
        return null;
    }
};

export const parseFileNameFromDisposition = (contentDisposition: string | null): string | null => {
    if (!contentDisposition) return null;

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
        try {
            return decodeURIComponent(utf8Match[1]);
        } catch {
            return utf8Match[1];
        }
    }

    const asciiMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    return asciiMatch?.[1] ?? null;
};
